import type { ReactNode } from "react";
import { SectionHelpTooltip } from "@/components/shared/SectionHelpTooltip";
import { cn } from "@/lib/utils";

type ModuleRegistryTitleProps = {
  title: string;
  /** aria-label кнопки «?». */
  helpLabel: string;
  /** Содержимое справки (зачем / как / клавиатура). */
  children: ReactNode;
  /**
   * true — свой `<h2>` (шапка с hideTitle, как сайдбар ГО/ОИ).
   * false — только текст (title уже внутри `<h2>` у EntityListPaneHeader).
   */
  withHeading?: boolean;
  className?: string;
};

/**
 * Заголовок реестра модуля + иконка «?» (SectionHelpTooltip), единый паттерн с ГО.
 */
export function ModuleRegistryTitle({
  title,
  helpLabel,
  children,
  withHeading = false,
  className,
}: ModuleRegistryTitleProps) {
  return (
    <span className={cn("inline-flex min-w-0 items-center gap-1.5", className)}>
      {withHeading ? (
        <h2 className="truncate text-sm font-semibold">{title}</h2>
      ) : (
        <span className="truncate">{title}</span>
      )}
      <SectionHelpTooltip label={helpLabel}>{children}</SectionHelpTooltip>
    </span>
  );
}
